import React, { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { VNDialog } from '../../VNCustomerFacingDisplay/components/VNDialog'
import { getCustomerViewingReceipt } from '../Selectors'
import { setCustomerViewingReceiptDialog } from '../ActionCreators'
import { clearCart } from '../../actions/cart'
import { clearPromotionsOnOrder } from '../../actions/promotion'
import { sendCFDScreenNav } from '../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { CFD_SCREEN } from '../../VNCustomerFacingDisplay/Reducer'
import { resetCFD } from '../../VNCustomerFacingDisplay/ActionCreators'
import useRemoteOrderTotal from '../../hooks/useRemoteOrderTotal'
import { clearOrderInProgress } from '../../actions/order'
import { isEmpty } from '../../VNUtil/VNUtils'
import { getOrderInProgress } from '../../selectors/order'
import { getPpiOrderDetails, getPpiConfigurations } from '../../VNPPI/Selectors'
import { getActiveAttendantId } from '../../selectors/attendant'
import { getActiveRevenueCenter } from '../../selectors/revenueCenter'
import { handlePpiReportOrder } from '../../VNPPI/Utils'
import { getPrintingEnabled } from '../../selectors/printer'
import usePrinter from '../../VNPrinters/hooks/usePrinter'
import queryString from 'query-string'

export const VNCustomerViewingReceiptDialog = () => {
  const dispatch = useDispatch()

  const history = useHistory()

  const dialogOptions = useSelector((state) => getCustomerViewingReceipt(state))
  const printingEnabled = useSelector((state) => getPrintingEnabled(state))
  const isOpen = dialogOptions?.get('open') || false

  const [, , resetOrderTotals] = useRemoteOrderTotal()
  const order = useSelector(getOrderInProgress)
  const ppiConfigurations = useSelector(getPpiConfigurations)
  const ppiOrderDetails = useSelector((state) => getPpiOrderDetails(state, order?.uuid))
  const activeAttendantId = useSelector(getActiveAttendantId)
  const activeRevenueCenter = useSelector(getActiveRevenueCenter)
  const { printReceipt } = usePrinter(dialogOptions?.get('uuid') || order?.uuid)
  const queryStrings = queryString.parse(window?.location?.search, { arrayFormat: 'comma' })

  const posInfo = {
    venueId: process.env.REACT_APP_VENUE_UUID,
    userId: activeAttendantId,
    vendorName: activeRevenueCenter.name,
    deviceId: window.localStorage.device_id,
  }

  // auto print the receipt if the dialog is opened
  useEffect(() => {
    if (queryStrings?.origin === 'orderDetails') return
    if (!isOpen) return
    if (!printingEnabled) return

    printReceipt(false, false, true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen])

  if (!isOpen) return null

  return (
    <VNDialog
      open={isOpen}
      subTitle={'Customer Viewing Receipt'}
      primaryButtonText={'NEW ORDER'}
      secondaryButtonText={printingEnabled && 'PRINT RECEIPT'}
      onSecondaryButtonClick={() => printReceipt()}
      onPrimaryButtonClick={() => {
        if (!isEmpty(order) && !isEmpty(ppiOrderDetails) && !isEmpty(ppiConfigurations) && !isEmpty(activeRevenueCenter)) {
          handlePpiReportOrder(
            order,
            ppiConfigurations,
            ppiOrderDetails,
            posInfo,
            activeRevenueCenter.customerAttributes?.ppiExtras,
          )
        }

        // clear cart
        dispatch(clearCart())

        // clear promotions on order
        dispatch(clearPromotionsOnOrder())

        // reset order totals
        resetOrderTotals()

        // navigate CFD back to IDLE
        sendCFDScreenNav(CFD_SCREEN.IDLE)

        // navigate POS back to
        history.push('/concession-order')

        // reset the state locally
        dispatch(resetCFD(true))

        // close dialog
        dispatch(setCustomerViewingReceiptDialog({ open: false }))

        dispatch(clearOrderInProgress())
      }}
    />
  )
}
